function determineTld() {
  const tld = window.location.origin.split(".").pop()

  if (tld === "dev") {
    return tld
  }
  return "com"
}

function determineAppUrl() {
  if (window.location.hostname === "localhost") {
    return window.location.origin
  }
  return `https://app.gobble.${TLD}`
}

export const TLD = determineTld()
const APP_URL = determineAppUrl()
const SITE_URL = `https://www.gobble.${TLD}`

export const LOGIN_URL = `${APP_URL}/login`
export const SIGNUP_URL = `${APP_URL}/signup/registrations/new`
export const TERMS_OF_USE_URL = `${SITE_URL}/terms`
export const PRIVACY_POLICY_URL = `${SITE_URL}/privacy`

export const REGISTRATION_ENDPOINT = `${APP_URL}/signup/registrations`
export const GRAPHQL_API_URL = `${APP_URL}/api/graphql`
